import React from "react";
import {
  useTranslation,
  LangType,
  TranslationKey,
} from "./hooks/useTranslation";

const projects = [
  {
    href: "https://marketplace.visualstudio.com/items?itemName=Yulia.motivator#review-details",
    titleKey: "motivatorTitle",
    descKey: "motivatorDesc",
    img: require("./images/Motivator_logo.png"),
    alt: "Motivator logo",
  },
  {
    href: "https://www.youtube.com/@songsforkidsua",
    titleKey: "studioTitle",
    descKey: "studioDesc",
    img: require("./images/youtube_channel.jpg"),
    alt: "YouTube channel logo",
  },
  {
    href: "https://mycoolcv.com/",
    titleKey: "cvTitle",
    descKey: "cvDesc",
    img: require("./images/MyCoolCV_logo.png"),
    alt: "My cool CV logo",
  },
  {
    href: "https://www.etsy.com/de-en/shop/FirstJulyStudio",
    titleKey: "etsyTitle",
    descKey: "etsyDesc",
    img: require("./images/etsy.webp"),
    alt: "Etsy shop logo",
  },
];

export const Projects: React.FC<{ lang?: LangType }> = ({
  lang = LangType.UA,
}) => {
  const t = useTranslation(lang);
  return (
    <main className="page-container">
      <section className="projects">
        {projects.map((project, idx) => (
          <div className="row-container" key={idx}>
            <div>
              <a href={project.href}>
                <span className="bold">
                  {t(project.titleKey as TranslationKey)}
                </span>
                <img className="logo" src={project.img} alt={project.alt} />
              </a>
            </div>
            <span className="text">{t(project.descKey as TranslationKey)}</span>
          </div>
        ))}
      </section>
    </main>
  );
};
